module.exports = {"content":{},"productInfo":{"code":"{07141570-ECB1-48FD-BF0E-E17D3CB2F8A9}","name":"スペイン語（ラテンアメリカ）　初中級","serialHead":"KYNRK","courseResourceIDs":[{"levelNo":1,"resourceID":"8ce4f161ddced4be0ec3ffb0eef7ab34bce61a28"},{"levelNo":2,"resourceID":"ac320f3fb12b94756edeed2157ebd9be342c4a37"},{"levelNo":3,"resourceID":"d0db7be7a332200136ad5aad561b63b56059c0f1"},{"levelNo":4,"resourceID":"dc9e4baef7097382154759583580953bfb4be1c0"},{"levelNo":5,"resourceID":"15758c3d7efe08547694b25d14555be39c0f6f5e"}],"language":"es-419","challengeCount":33559},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1